import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { UsuariosIndexComponent } from './UsuariosIndex.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';

const routes = [
{
	path     : 'Usuarios/:cnumcont',
	component: UsuariosIndexComponent,
	canActivate: [RoleGuard], 
	data: { 
		formulario: 'Negocio',
        nombreFormulario : 'Usuarios Contrato'
	} 
}

];

@NgModule({
	declarations: [
	UsuariosIndexComponent
	],
	imports     : [
	SharedModule,
	RouterModule.forChild(routes)
	],
	exports     : [
	UsuariosIndexComponent
	],
	bootstrap: [UsuariosIndexComponent],
})

export class UsuariosModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Usuarios/Usuarios.module.ts